import { render } from "./Booking_Header.vue?vue&type=template&id=d1131274&scoped=true"
import script from "./Booking_Header.vue?vue&type=script&lang=js"
export * from "./Booking_Header.vue?vue&type=script&lang=js"

import "./Booking_Header.vue?vue&type=style&index=0&id=d1131274&lang=stylus&scoped=true"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1131274"]])

export default __exports__